import React, { memo, useMemo } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import moment from 'moment'

import { weekDays } from '../../../constants'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const options = {
  maintainAspectRatio: false,
  tension: 0.4,
  responsive: true,
  scales: {
    x: {
      display: true,
      grid: {
        drawBorder: false,
        display: false,
      },
      ticks: {
        color: '#F67443',
      },
    },
    y: {
      display: true,
      grid: {
        drawBorder: false,
        color: '#F9E0CD',
        zeroLineColor: '#F9E0CD',
      },
      ticks: {
        maxTicksLimit: 6,
        callback: function (value) {
          return parseInt(value)
        },
        color: '#F67443',
      },
    },
  },
  plugins: {
    legend: {
      display: false,
      position: 'top',
    },
    title: {
      display: false,
    },
  },
}

export const BarChart = memo(({ stats = [], datasets = [], interval }) => {
  const labels = useMemo(() => {
    if (interval === 'Week') {
      return weekDays
    }

    if (interval === 'Month') {
      return stats.map((_, index) => {
        return `Week ${index + 1}`
      })
    }

    if (interval === 'Year') {
      return stats.map((stat) => {
        return moment(stat.month).format('MMMM')
      })
    }

    return []
  }, [stats, interval])

  const data = {
    labels,
    datasets: datasets.map((dataset, index) => {
      return {
        fill: true,
        data: stats[index]?.[dataset.key] || 0,
        borderColor: dataset.color,
        backgroundColor: dataset.color,
        borderRadius: 4,
      }
    }),
  }

  return (
    <Bar
      width="1140"
      style={{ width: '100%', height: '100%', maxHeight: '100%' }}
      options={options}
      data={data}
    />
  )
})
